export const getNivelSocioeconomico = (values) => ({
    persona: localStorage.getItem("persona_id"),
    con_quien_reside: values.conQuienReside.id,
    indique_con_quien_reside: values.conQuienReside.id == 23 ? values.otroConQuienReside: null,   
    estrato: parseInt(values.estrato.detalle),
    dependende_economicamente: values.dependeEconómicamente.id,
    puntaje_sisben: values.tienePuntajeSisben.id,
    indique_puntaje_sisben:
    values.tienePuntajeSisben.id === 30
    ? values.cualPuntajeSisben.id
    : null,
    hace_parte_listado_censal: values.listadoCensal.id,
    cual_listado_censal:
    values.listadoCensal.id === 30 ? values.indiqueListadoCensal.id : null,
    otro_listado_censal:
    values.listadoCensal.id == 30 && values.indiqueListadoCensal.id == 116
    ? values?.cualListadoCensal
    : null,
    
});
export const getSistemaSalud = (values) => ({
    persona: localStorage.getItem("persona_id"),
    hace_parte_agremiacion_asociacion_salud: values.agremiación.id,
    tipo_agremiacion_asociacion_salud:
        values.agremiación.id == 30 ? values?.tipoAgremiación?.id : null,
    nombre_agremiacion_asociacion_salud:
        values.agremiación.id == 30 && values?.tipoAgremiación?.id == 108
            ? values.cualAgremiación
            : null,
    forma_afiliacion_salud: values.afiliaciónSalud.id,
    tiene_discapacidad: values.tieneDiscapacidad.id,
    tipo_discapacidad:
        values.tieneDiscapacidad.id == 30 ? values.cualDiscapacidad.id : null,
    indique_discapacidad_otra:
        values.tieneDiscapacidad.id == 30 && values.cualDiscapacidad.id == 461
            ? values?.cualOtraDiscapacidad
            : null,
});
